module.exports = __webpack_public_path__ + "img/tt2p.ab38ca4e.png";